import React from "react";
import { useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const CustomizedLabel = ({ x, y, stroke, value }) => {
  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
      {value}
    </text>
  );
};

const CustomizedAxisTick = ({ x, y, stroke, payload }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-35)"
      >
        {payload.value}
      </text>
    </g>
  );
};

const PaymentGraph = () => {
  const url = "api/v1/collections/fetch-dashboard";
  const { data, count, loading } = useSelector((state) => ({
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    loading: state.fetch.loading[url],
  }));
  return (
    <div className="w-full h-full white_card flex flex-col">
      <h3 className="heading_4 ">Payment Graph</h3>
      <ResponsiveContainer width="100%" height={700}>
        <LineChart
          width={500}
          height={300}
          data={data?.graphData}
          margin={{
            top: 40,
            right: 30,
            left: 50,
            bottom: 40,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" height={60} tick={<CustomizedAxisTick />} />
          <YAxis
            tickFormatter={(value) => new Intl.NumberFormat().format(value)}
          />
          <Tooltip
            formatter={(value) => new Intl.NumberFormat().format(value)}
          />
          <Legend layout="horizontal" verticalAlign="top" align="center" />
          <Line
            type="monotone"
            dataKey="paidIn"
            stroke="#8884d8"
            label={<CustomizedLabel />}
          />
          <Line type="monotone" dataKey="paidOut" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentGraph;
